module.exports = {
	"classes": [
		"signup-page"
	],
	"title": "Sign Up",
	"metas": {
		"description": "Single Sign On & Token Based Authentication"
	},
	"opengraph": {
		"og:title": "Sign Up",
		"og:description": "Single Sign On & Token Based Authentication",
		"og:url": "https://auth0.com/signup",
		"og:image": "/pages/opengraph/1x-new.png",
		"og:image:secure_url": "/pages/opengraph/1x-new.png"
	},
	"twittercard": {
		"twitter:title": "Sign Up",
		"twitter:description": "Single Sign On & Token Based Authentication",
		"twitter:image": [
			{
				"src": "/pages/twittercard/1x-new.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/signup/data/metadata.json
// module id = 1143
// module chunks = 0